<template>
    <div class="main">
        <c-panel title="SOLICITAÇÕES DE KIT ALIMENTAÇÃO" titleIcon="fas fa-utensils">
            <el-row :gutter="10" class="u-mb-10">
                <el-col :sm="6">
                    <el-select v-model="filtro.status" placeholder="Status" clearable @change="load" style="width:100%;">
                        <el-option v-for="s in STATUS" :key="s.v" :label="s.l" :value="s.v"></el-option>
                    </el-select>
                </el-col>
                <el-col :sm="18" class="u-text-right">
                    <el-button @click="load" icon="el-icon-search">FILTRAR</el-button>
                    <el-button class="u-ml-10" type="primary" icon="el-icon-plus" @click="abrirNovo">NOVA SOLICITAÇÃO</el-button>
                </el-col>
            </el-row>

            <table class="table table-striped">
                <thead><tr>
                    <th style="width:70px;">Cod</th>
                    <th>Aluno</th>
                    <th style="width:130px;">Data sol.</th>
                    <th style="width:130px;">Data entrega</th>
                    <th style="width:140px;">Status</th>
                    <th>Justificativa</th>
                    <th style="width:200px;" class="u-text-center">Ações</th>
                </tr></thead>
                <tbody>
                    <tr v-for="s in items" :key="s.id">
                        <td>{{ s.id }}</td>
                        <td>{{ s.aluno ? s.aluno.nome : '—' }}</td>
                        <td>{{ s.data_solicitacao | formatarData }}</td>
                        <td>{{ s.data_entrega | formatarData }}</td>
                        <td><el-tag size="mini" :type="tagStatus(s.status)">{{ rotuloStatus(s.status) }}</el-tag></td>
                        <td>{{ s.justificativa || '—' }}</td>
                        <td class="u-text-center">
                            <el-button v-if="s.status !== 4 && s.status !== 3" size="mini" type="warning" plain @click="abrirMudarStatus(s)">STATUS</el-button>
                            <el-button class="u-ml-10" v-if="s.status === 1" size="mini" type="danger" plain icon="el-icon-delete" @click="excluir(s.id)"></el-button>
                        </td>
                    </tr>
                    <tr v-if="!items.length"><td colspan="7" class="u-text-center" style="color:#909399;padding:15px;">Nenhuma solicitação.</td></tr>
                </tbody>
            </table>

            <el-dialog title="Nova solicitação" :visible.sync="modalNovoVisivel" width="500px">
                <el-form label-position="top">
                    <el-form-item label="Aluno">
                        <el-select v-model="form.aluno_id" filterable remote :remote-method="buscarAluno" :loading="loadAluno" placeholder="Digite..." style="width:100%;">
                            <el-option v-for="a in alunosBusca" :key="a.id" :label="a.nome" :value="a.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="Data da solicitação">
                        <el-date-picker v-model="form.data_solicitacao" type="date" format="dd/MM/yyyy" value-format="yyyy-MM-dd" style="width:100%;"></el-date-picker>
                    </el-form-item>
                    <el-form-item label="Justificativa">
                        <el-input type="textarea" v-model="form.justificativa" :rows="3" placeholder="Aluno usa transporte e não almoça na escola."></el-input>
                    </el-form-item>
                </el-form>
                <span slot="footer">
                    <el-button @click="modalNovoVisivel = false">CANCELAR</el-button>
                    <el-button class="u-ml-10" type="primary" @click="salvar">SOLICITAR</el-button>
                </span>
            </el-dialog>

            <el-dialog title="Mudar status" :visible.sync="modalStatusVisivel" width="400px">
                <p v-if="atual"><strong>{{ atual.aluno ? atual.aluno.nome : '?' }}</strong> — atual: {{ rotuloStatus(atual.status) }}</p>
                <el-select v-model="novoStatus" style="width:100%;">
                    <el-option v-for="s in STATUS" :key="s.v" :label="s.l" :value="s.v" :disabled="atual && s.v === atual.status"></el-option>
                </el-select>
                <span slot="footer">
                    <el-button @click="modalStatusVisivel = false">CANCELAR</el-button>
                    <el-button class="u-ml-10" type="primary" @click="confirmarStatus">APLICAR</el-button>
                </span>
            </el-dialog>
        </c-panel>
    </div>
</template>

<script>
import moment from 'moment'
const STATUS = [
    { v: 1, l: 'Solicitado' }, { v: 2, l: 'Preparado' },
    { v: 3, l: 'Entregue' }, { v: 4, l: 'Cancelado' }
]
export default {
    filters: { formatarData (v) { return v ? moment(v).format('DD/MM/YYYY') : '' } },
    data () {
        return {
            STATUS, items: [], filtro: { status: null },
            modalNovoVisivel: false, form: this.formVazio(),
            alunosBusca: [], loadAluno: false,
            modalStatusVisivel: false, atual: null, novoStatus: null
        }
    },
    mounted () { this.load() },
    methods: {
        baseUrl () { return this.$store.state.config.baseUrlApi },
        instId () { const i = this.$store.state.config.instituicao; return i && i.id ? i.id : null },
        formVazio () { return { aluno_id: null, instituicao_id: this.instId(), data_solicitacao: moment().format('YYYY-MM-DD'), justificativa: '' } },
        rotuloStatus (s) { const x = STATUS.find(o => o.v === Number(s)); return x ? x.l : '?' },
        tagStatus (s) { return { 1: 'info', 2: 'warning', 3: 'success', 4: 'danger' }[s] || '' },

        load () {
            this.$axios.post(`${this.baseUrl()}/api/kit-alimentacao/getAllPaginate`,
                { instituicao_id: this.instId(), ...this.filtro },
                this.$store.getters.getHeaderAuth
            ).then(r => { this.items = (r.data && r.data.data) ? r.data.data : (r.data || []) })
              .catch(e => this.$store.commit('throwException', e))
        },
        buscarAluno (q) {
            if (!q || q.length < 2) { this.alunosBusca = []; return }
            this.loadAluno = true
            this.$axios.post(`${this.baseUrl()}/api/aluno/searchByNome`, { query: q }, this.$store.getters.getHeaderAuth)
                .then(r => { this.alunosBusca = r.data || []; this.loadAluno = false })
                .catch(() => { this.loadAluno = false })
        },
        abrirNovo () { this.form = this.formVazio(); this.alunosBusca = []; this.modalNovoVisivel = true },
        salvar () {
            this.$axios.post(`${this.baseUrl()}/api/kit-alimentacao/store`, this.form, this.$store.getters.getHeaderAuth).then(r => {
                if (r.data && r.data.erro) {
                    window.eventBus.$emit('alert', { msg: typeof r.data.erro === 'string' ? r.data.erro : r.data.erro.text, type: 'warning' })
                    return
                }
                window.eventBus.$emit('alert', { msg: 'Solicitação criada.', type: 'success' })
                this.modalNovoVisivel = false
                this.load()
            })
        },
        excluir (id) {
            this.$confirm('Excluir solicitação?', 'Confirmar', { type: 'warning' }).then(() => {
                this.$axios.delete(`${this.baseUrl()}/api/kit-alimentacao/delete/${id}`, this.$store.getters.getHeaderAuth).then(r => {
                    if (r.data && r.data.erro) { window.eventBus.$emit('alert', { msg: r.data.erro, type: 'warning' }); return }
                    this.load()
                })
            }).catch(() => {})
        },
        abrirMudarStatus (s) { this.atual = s; this.novoStatus = null; this.modalStatusVisivel = true },
        confirmarStatus () {
            if (!this.novoStatus) { window.eventBus.$emit('alert', { msg: 'Selecione um status.', type: 'warning' }); return }
            this.$axios.post(`${this.baseUrl()}/api/kit-alimentacao/mudarStatus/${this.atual.id}`,
                { status: this.novoStatus }, this.$store.getters.getHeaderAuth
            ).then(r => {
                if (r.data && r.data.erro) {
                    window.eventBus.$emit('alert', { msg: typeof r.data.erro === 'string' ? r.data.erro : r.data.erro.text, type: 'warning' })
                    return
                }
                this.modalStatusVisivel = false
                this.load()
            })
        }
    }
}
</script>
